import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { CONTACT } from '../../data/content';
import '../../styles/floating.css';

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${CONTACT.whatsapp}`}
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}
